import { render, staticRenderFns } from "./CadastroEmpresa.vue?vue&type=template&id=4a08393e&scoped=true&"
import script from "./CadastroEmpresa.vue?vue&type=script&lang=js&"
export * from "./CadastroEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./CadastroEmpresa.vue?vue&type=style&index=0&id=4a08393e&scoped=true&lang=css&"
import style1 from "./CadastroEmpresa.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a08393e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VChipGroup,VCol,VRow,VTextField})
